import { render, staticRenderFns } from "./AddPlateformAccount.vue?vue&type=template&id=5bf20906&scoped=true&"
import script from "./AddPlateformAccount.vue?vue&type=script&lang=js&"
export * from "./AddPlateformAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddPlateformAccount.vue?vue&type=style&index=0&id=5bf20906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf20906",
  null
  
)

export default component.exports